import styled from 'styled-components';
export const ModalHeaderStyle = styled.div.withConfig({
  componentId: "sc-17glmq9-0"
})(["&{", " div.title{", " >div{", "}}}"], {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "borderBottomWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderBottomColor": "rgb(227 232 239 / var(--tw-border-opacity, 1))",
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "1rem",
  "paddingBottom": "1rem",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "700"
}, {
  "display": "flex",
  "alignItems": "center",
  "gap": "0.75rem"
}, {
  "height": "100%",
  "minHeight": "1.5rem",
  "width": "0.75rem",
  "borderRadius": "0.25rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(162 194 255 / var(--tw-bg-opacity, 1))"
});
export const ModalBodyStyle = styled.div.withConfig({
  componentId: "sc-17glmq9-1"
})(["&{", " padding:1.5rem;width:", ";max-height:", ";overflow:", ";background-color:", ";gap:1.5rem;}"], {
  "display": "flex",
  "flexWrap": "wrap",
  "alignItems": "flex-end"
}, props => props.bodyWidth ? props.bodyWidth : '31.25rem', props => props.bodyHeight ? props.bodyHeight : '', props => props.bodyHeight ? 'auto' : '', props => props.bgColor ? props.bgColor : '');
export const ModalFooterStyle = styled.div.withConfig({
  componentId: "sc-17glmq9-2"
})(["&{", " gap:0.5rem;justify-content:", ";}"], {
  "display": "flex",
  "borderTopWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderTopColor": "rgb(227 232 239 / var(--tw-border-opacity, 1))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem"
}, props => props.justify ?? 'space-between');
export const ModalFooterButtonBoxStyle = styled.div.withConfig({
  componentId: "sc-17glmq9-3"
})(["&{", " gap:0.5rem;justify-content:", ";}"], {
  "display": "flex",
  "flexGrow": "1",
  "alignItems": "center"
}, props => props.justify ?? 'flex-end');
export const NoContentModalBodyStyle = styled.div.withConfig({
  componentId: "sc-17glmq9-4"
})(["&{", " div:first-child{", "}}"], {
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "paddingLeft": "2.5rem",
  "paddingRight": "2.5rem",
  "paddingBottom": "1.75rem",
  "paddingTop": "3rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(32 41 57 / var(--tw-text-opacity, 1))"
}, {
  "marginBottom": "0.25rem",
  "fontSize": "1.125rem",
  "lineHeight": "1.5rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
});
export const DialogModalStyle = styled.div.withConfig({
  componentId: "sc-17glmq9-5"
})(["&{> div.modal-content{width:calc(100% - 5rem);min-width:18rem;max-width:25rem;> div.body{", " > div:first-child{", "}> div:nth-child(2){", "}}> div.modal-footer{", " > button{flex:1;min-width:1px;}}}}"], {
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "0.5rem",
  "paddingBottom": "1.5rem"
}, {
  "fontSize": "1.125rem",
  "lineHeight": "1.5rem",
  "fontWeight": "700"
}, {
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500"
}, {
  "display": "flex",
  "justifyContent": "center",
  "gap": "1rem",
  "textAlign": "center"
});